const defaultEnabledList = { header: true, search: true, filter: false };

const defaultPagination = {
  enabled: true,
  perPageSelection: false,
  rowsPerPageOptions: [5, 10, 15, 20]
};

export { defaultEnabledList, defaultPagination };
